import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Icon,
  Input,
  Modal,
  Drawer,
  notification,
  Row,
  Select,
  Table,
  Tooltip
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import React, { PureComponent, useState } from 'react'

import { connect } from 'react-redux'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import { getPushPathWrapper, getUrlParams } from '../../../routes'

import {
  ArticleTypeList,
  chooseEmailModalFxn,
  Countries,
  CustomCkEditor,
  DesignationList,
  InputBox,
  mentionsFeeds,
  NotificationBox,
  ProcessList
} from '../../../components/_utils/appUtils'

import { addCourierFxn, addSubscriptionActivityFxn } from '../action'
import Request from '../../../request'

@Form.create()
class AddCourierDrawer extends PureComponent {
  state = {
    journal: '',
    mode: '',
    copies: '',
    date: '',
    volumeName: '',
    issues: []

  }
  events = {
    removeStateCountry: (index) => {
      let cloneArr = _.clone(this.state.courierDetails)
      cloneArr.splice(index, 1)
      this.setState({
        courierDetails: cloneArr
      })
    }
  }

  constructor(props) {
    super(props)
    this.state = {
      courierDetails: [],
      journalNameList: [], // We will fill this from API now
      journalVolumeList: [],
      journalIssueList: [],

      selectedYear: undefined,
      selectedJournal: undefined,

      yearList: []
    }
  }

  componentDidMount() {
    let urlObj = getUrlParams('singleGeneralSubscription', window.location.pathname)
    if (urlObj && urlObj.id) {
      this.fetchJournalData(urlObj.id)
    } else {
      this.getJournalList()
    }

    // this.loadJournalList()
    // this.getJournalList()

    let data = getUrlParams('article.onlineSubmission', this.props.pathname)
    if (!!data) {
      let { id } = data
      this.setFormValuesFxn(id)
    }
  }

  fetchJournalData = async (id) => {
    console.log("DEBUG: Calling API for ID:", id);
    try {
      let { data, success } = await Request.getSubscriptionJournals(id);
      console.log("DEBUG: API Response:", JSON.stringify(data));
      if (success || data) {
        // Map the API response to the format expected by the dropdown
        const mappedData = (data.data || data).map(item => ({
          _id: String(item.journalId), // Ensure _id is a string
          display: item.display,
          value: item.display,
          years: item.years || [] // Default to empty array if missing
        }));
        console.log("DEBUG: Mapped Journal Data:", JSON.stringify(mappedData));
        this.setState({ journalNameList: mappedData });
      }
    } catch (error) {
      console.error("DEBUG: API Failed:", error);
    }
  }

  getYearsData = (journalId) => {
    console.log("DEBUG: getYearsData called with ID:", journalId, typeof journalId);
    console.log("DEBUG: Current Journal List:", JSON.stringify(this.state.journalNameList));
    // Convert input ID to string for comparison
    const searchId = String(journalId);
    const selectedJournal = this.state.journalNameList.find(j => String(j._id) === searchId);
    console.log("DEBUG: Found Journal:", selectedJournal);
    if (selectedJournal && selectedJournal.years && selectedJournal.years.length > 0) {
      const yearList = selectedJournal.years.map(y => ({ _id: y, name: y }));
      console.log("DEBUG: Setting Year List:", yearList);
      this.setState({ yearList });
    } else {
      console.log("DEBUG: No years found for journal");
      this.setState({ yearList: [] });
    }
  }

  resetFormData = () => {
    const { dispatch, form } = this.props
    form.setFieldsValue({
      journal: '',
      mode: '',
      copies: '',
      date: '',
      volumeName: '',
      issues: []
    })
  }



  async AddCourierDetails() {
    const {
      form: { getFieldValue, setFieldsValue }
    } = this.props
    let journal = getFieldValue('journal') ? getFieldValue('journal') : undefined

    let copies = getFieldValue('copies') ? getFieldValue('copies') : undefined
    let volumeName = getFieldValue('volumeName') ? getFieldValue('volumeName') : undefined
    let issues = getFieldValue('issues') ? getFieldValue('issues') : undefined
    if (journal == undefined) {
      notification.error({
        message: 'Please choose Journal Name.'
      })
      return
    }


    if (copies == undefined) {
      notification.error({
        message: 'Please select copies'
      })
      return
    }
    if (volumeName == undefined) {
      notification.error({
        message: 'Please select volume'
      })
      return
    }
    if (issues == undefined) {
      notification.error({
        message: 'Please select issues'
      })
      return
    }
    let obj = {
      journal: journal,
      copies: copies,
      volumeName: volumeName,
      issues: issues
    }
    let cloneD = _.clone(this.state.courierDetails)

    this.setState({ courierDetails: [...cloneD, obj] })

    setFieldsValue({
      journal: undefined,
      copies: undefined,
      volumeName: undefined,
      issues: []
    })

    // }
  }

  getJournalList = async () => {
    // We are now using the journal list derived from the subscription invoices in the constructor.
    // This ensures only relevant journals are shown.
    // If we want to allow adding ANY journal, uncomment the API call below.
    /*
    console.log('DEBUG: getJournalList called')
    let { data } = await Request.journalName()
    console.log('DEBUG: journalName API response:', data)
    let journalList = []
    _.each(data, item => {
      journalList.push({
        _id: item._id,
        value: item.slugJournal,
        display: item.name
      })
    })
    console.log('DEBUG: journalList after processing:', journalList)
    this.setState({ journalNameList: journalList }, () => {
      console.log('DEBUG: journalNameList state after setState:', this.state.journalNameList)
    })
    */
  }


  chooseDocument = e => {
    let { name, files } = e.target
    if (files && files.length) {
      this.setState({ [name]: files[0] })
    }
  }
  getJournalsVolumeData = async (id) => {
    let { data } = await Request.getJournalsVolumeList({ journalId: id })
    let volumeList = []
    _.each(data, (item) => {
      volumeList.push({
        _id: item._id,
        name: item.volumeName
      })
    })

    this.setState({ journalVolumeList: volumeList })
  }
  getJournalsIssueData = params => {
    return new Promise(async resolve => {
      const {
        form: { getFieldDecorator, getFieldValue, setFieldsValue },
        loading
      } = this.props
      let journal = getFieldValue('journal') ? getFieldValue('journal') : undefined

      let { data } = await Request.getJournalIssue({ journalId: journal, volumeId: params })
      this.setState({ total: data.total })
      let issueList = []
      _.each(data, (item) => {
        issueList.push({
          _id: item._id,
          name: item.issueName
        })
      })

      this.setState({ journalIssueList: issueList })
    })
  }

  handleSubmit = e => {
    const { dispatch, form } = this.props
    let urlObj = getUrlParams('singleGeneralSubscription', window.location.pathname)
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        if (this.state.courierDetails.length === 0) {
          notification.error({
            message: 'Please add at least one journal details to the list before submitting.'
          })
          return
        }
        valData.generalSubscriptionId = urlObj.id
        if (this.props.missingIssues) {
          valData.missingIssues = this.props.missingIssues
        }
        valData.courierDetails = this.state.courierDetails

        let { success, message } = await dispatch(addCourierFxn(valData))
        if (success) {
          notification.success({
            message: message
          })
          this.props.reloadData()
          this.resetFormData()
          this.props.onClose()
        }
      }
    })


  }

  render() {
    const {
      form: { getFieldDecorator, getFieldValue, setFieldsValue },
      loading
    } = this.props
    const { edit, journalListArr, lastArticleNo, visibleAddAuthor } = this.state

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 24 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 24 }
      }
    }

    const inputSchma = {
      fields: [


        // {
        //   label: 'Tracking No',
        //   key: 'trackingNo',
        //   required: true,
        //   placeholder: 'Tracking No',
        // },
        {
          label: 'Date',
          key: 'date',
          required: true,
          placeholder: 'Date',
          type: 'date'
        },
        {
          label: 'Mode',
          key: 'mode',
          required: true,
          placeholder: 'Mode'
        },
        {
          title: 'Tracking No',
          name: 'TrackingNo',
          key: 'TrackingNo',
          dataIndex: 'TrackingNo'
        }


      ],
      multiFields: [
        {
          label: 'Journal Name',
          key: 'journal',
          placeholder: 'Select Journal', // Updated placeholder
          type: 'select',
          // required: true, 
          keyAccessor: x => x.journalId || x._id, // Updated for API structure
          valueAccessor: x => x.journalName || x.display || x.name, // Updated for API structure
          options: this.state.journalNameList,
          onChange: (journalId) => {
            const { form } = this.props;

            // 1. Force the Form UI to forget the current year immediately
            form.setFieldsValue({
              journal: journalId, // <-- CRITICAL: Update the journal value!
              year: undefined
            });

            // 2. Get the specific years for this journal from state
            const selected = this.state.journalNameList.find(j =>
              (j.journalId === journalId) || (j._id === journalId)
            );
            const availableYears = selected ? selected.years : [];

            // 3. Update state (New Year List + Clear Selected Year)
            this.setState({
              selectedJournal: journalId,
              yearList: availableYears.map(y => ({ value: String(y), display: String(y) })),
              selectedYear: undefined
            });

            if (journalId) {
              this.getJournalsVolumeData(journalId);
            }
          }
        },
        {
          label: 'Year',
          key: 'year',
          placeholder: 'Select Year',
          allowClear: true, // <--- Added as requested
          type: 'select',
          keyAccessor: x => x.value,
          valueAccessor: x => x.display,
          options: this.state.yearList,
          disabled: !this.state.selectedJournal, // Disable until journal selected
          onChange: (year) => {
            console.log("DEBUG: Year Selected:", year);
            this.setState({ selectedYear: year });
            this.props.form.setFieldsValue({ year: year });
          }
        },
        {
          label: 'Copies',
          key: 'copies',
          // required: true,
          placeholder: 'Copies',
          type: 'number'

        },
        {
          label: 'Volume',
          key: 'volumeName',
          placeholder: 'Select',
          type: 'select',
          // required: true,
          disabled: !this.state.selectedJournal,
          keyAccessor: x => x.name,
          valueAccessor: x => x.name,
          options: this.state.journalVolumeList,
          onChange: async (selectedVolume) => {
            const { form: { setFieldsValue } } = this.props
            setFieldsValue({
              volumeName: selectedVolume,
              issues: []
            })
            const selectedObj = this.state.journalVolumeList.find(
              x => x.name === selectedVolume
            )
            await this.getJournalsIssueData(selectedObj._id)
            setFieldsValue({
              volumeId: selectedObj._id
            })
          }
        },
        {
          label: 'Issue',
          key: 'issues',
          placeholder: 'Select',
          type: 'select',
          // required: true,
          mode: 'multiple',
          disabled: !this.state.selectedJournal,
          keyAccessor: x => x.name,
          valueAccessor: x => x.name,
          options: this.state.journalIssueList,

          onChange: (e) => {
            const { form: { setFieldsValue } } = this.props
            setFieldsValue({
              issues: e
            })
          }
        },
        {
          key: 'add',
          span: 4,
          customField: (
            <InputBox title={'Add'}>
              <a className='btn mt10' type='primary'
                onClick={() => {
                  this.AddCourierDetails()
                }}
                style={{ backgroundColor: '#1556bc', textColor: 'white', color: 'white' }}>
                ADD
              </a>
            </InputBox>
          )
        }
      ]


    }
    const assignColumns = [
      {
        title: 'Journal Name',
        key: 'journal',
        dataIndex: 'journal',
        render: (record, index) => {
          const item = this.state.journalNameList.find(j => j._id == record)

          return <>{item ? item.display : '-'}</>
        }
      },
      {
        title: 'Volume',
        key: 'volumeName',
        dataIndex: 'volumeName'

      },
      {
        title: 'Issues',
        key: 'issues',
        dataIndex: 'issues',
        render: (item) => {
          return (
            <div>
              {item && item.length ? item.join(', ') : null}
            </div>
          )
        }
      },
      {
        title: 'Copies',
        key: 'copies',
        dataIndex: 'copies'
      },
      {
        title: 'Action',
        key: 'action',
        dataIndex: 'action',
        render: (item, record, index) => {
          return (
            <Icon type={'close'}
              style={{ color: 'red' }}
              onClick={() => {
                this.events.removeStateCountry(index)
              }} />
          )
        }
      }

    ]
    return (
      <Drawer
        title={`${this.props.missingIssues === true ? 'Add Missing Details' : 'Add Courier Details'}`}
        width={'45%'}
        visible={this.props.visible}
        maskClosable={true}
        placement='right'
        onClose={this.props.onClose}>
        <Card bordered={true}>
          <Form
            onSubmit={this.handleSubmit}
            hideRequiredMark
            className={'inputForm'}>
            <Row gutter={16}>
              <Col span={24}>
                <Card bordered={true}>
                  <Row gutter={16}>
                    {inputSchma.fields.map((item, key) => {
                      return (
                        !item.hidden && (
                          <Col
                            span={item.span ? item.span : 8}
                            md={item.span ? item.span : 8}
                            sm={12}
                            xs={24}
                            key={key}>
                            {item.customField ? (
                              item.customField
                            ) : (
                              <GetEachFormFields
                                item={item}
                                getFieldDecorator={getFieldDecorator}
                                formItemLayout={formItemLayout}
                              />
                            )}
                          </Col>
                        )
                      )
                    })}

                  </Row>
                  <Row gutter={16}>
                    {inputSchma.multiFields.map((item, key) => {
                      return (
                        !item.hidden && (
                          <Col
                            span={item.span ? item.span : 6}
                            md={item.span ? item.span : 12}
                            sm={12}
                            xs={24}
                            key={key}>
                            {item.customField ? (
                              item.customField
                            ) : (
                              <GetEachFormFields
                                item={item}
                                getFieldDecorator={getFieldDecorator}
                                formItemLayout={formItemLayout}
                              />
                            )}
                          </Col>
                        )
                      )
                    })}

                  </Row>
                </Card>
              </Col>

            </Row>
            <Row gutter={16}>
              <Table dataSource={this.state.courierDetails}
                className={'table table-bordered'}
                bordered={true} size={'small'}
                pagination={false} columns={assignColumns} />
            </Row>

            <Form.Item style={{ marginTop: 32 }}>
              <Button type='primary' htmlType='submit'>
                SUBMIT
              </Button>
            </Form.Item>
          </Form>


        </Card>
      </Drawer>
    )
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
  pathname: router.location.pathname

})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(mapStateToProps,
  mapDispatchToProps
)(AddCourierDrawer)
